(function () {
  function init() {
    var track = document.getElementById('jc-reviews-track');
    if (!track) return;
    var URL = 'https://cdn.judge.me/reviews/reviews_for_carousel?reviews_selection=all&carousel_type=cards&star_rating=4_to_5_star&max_reviews=15&url=https%3A%2F%2Fjust-casual.com&shop_domain=rkjhbd-m0.myshopify.com&platform=shopify&primary_language=de&display_order=media_first';
    function stars(n){ n=Math.round(n||5); var s=''; for(var i=0;i<5;i++) s+= i<n?'★':'☆'; return s; }
    function esc(t){ var d=document.createElement('div'); d.textContent=t||''; return d.innerHTML; }
    function render(revs){
      revs = (revs||[]).filter(function(r){ return (r.body||'').trim(); });
      if(!revs.length){ document.getElementById('reviews').style.display='none'; return; }
      track.innerHTML = revs.map(function(r){
        var ini=(r.reviewer_initial||(r.reviewer_name||'?').charAt(0)).toUpperCase();
        return '<div class="jc-review-card"><div class="jc-review-stars">'+stars(r.rating)+'</div>'
          +'<p class="jc-review-body">'+esc(r.body.trim())+'</p>'
          +'<div class="jc-review-author"><span class="jc-review-avatar">'+esc(ini)+'</span>'
          +'<div><div class="jc-review-name">'+esc(r.reviewer_name||'Kunde')+'</div>'
          +'<div class="jc-review-meta">'+((window.jcT&&jcT.verified)||'✓ Verifiziert')+'</div></div></div></div>';
      }).join('');
    }
    var cached=null; try{ cached=JSON.parse(sessionStorage.getItem('jc_reviews')); }catch(e){}
    if(cached) render(cached);
    fetch(URL).then(function(r){return r.json();}).then(function(d){
      if(d&&d.reviews){ try{ sessionStorage.setItem('jc_reviews', JSON.stringify(d.reviews)); }catch(e){} render(d.reviews); }
    }).catch(function(){ if(!cached) document.getElementById('reviews').style.display='none'; });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();